export const QueryKey = 'banner'
export const Banner = '/api/v1/sanity/banner/'
